import { CourseType, EnrolState } from 'enum'
import { ICourseModel } from 'models/course.model'

export const hasAccessToCourse = (course: ICourseModel) => {
  const { enrol } = course

  if (course.courseType === CourseType.Closed) {
    /**
     * Si el curso es cerrado y no tiene enrol, no tiene acceso
     */
    if (!enrol) return false

    // Si el enrol está en estado pendiente, no tiene acceso
    return enrol.stateAdmin !== EnrolState.Pending
  }

  return true
}
